export const defaultInfos = [
  {
    contents:
      '품목은 반품택배로 수거하며, 기사님이 수거하기까지 2-3일 정도가 소요됩니다.',
  },
  {
    contents:
      '크레딧은 보내주신 순환자원의 무게(1000g=10C)로 지급하고 있습니다.',
  },
];
export const defaultCautions = [
  {
    contents:
      '수거신청 주소는 명확히 기재해야 합니다. 만약 잘못된 주소를 기입할 시 수거가 지연될 수 있습니다.',
  },
  {
    contents:
      '수거신청한 박스는 반드시 문 앞에 내놓아야 합니다. 위치를 알기 힘든 곳에 두게 되면 분실사고의 위험이 높아집니다.',
  },
  {
    contents: '수거신청을 완료하면 얼스 크레딧이 지급됩니다.',
  },
];
